import { type TagLabelNamespace, translateTagName } from '@pulsify/shared/tag-labels'
import { getLocale } from '~/paraglide/runtime.js'

function humanizeTagName(name: string): string {
  return name
    .replace(/([A-Z])/g, ' $1')
    .trim()
    .replace(/ And /g, ' & ')
}

/** "FamilyFriendly" → "Familienfreundlich" / "Family Friendly"; untranslated names are spaced out. */
export function formatTagLabel(
  name: string,
  namespace: TagLabelNamespace = 'labels',
  locale: string = getLocale(),
): string {
  return translateTagName(name, namespace, locale === 'en' ? 'en' : 'de') ?? humanizeTagName(name)
}
